import { MoigoihomsauService } from 'src/services/moigoihomsau.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const MOIGOIHOMSAU_NEW_CARE_SUCCESS = 'MOIGOIHOMSAU:NEW_CARE_SUCCESS'
export const MOIGOIHOMSAU_LIST_SUCCESS = 'MOIGOIHOMSAU:FIND_ALL_SUCCESS'
export const MOIGOIHOMSAU_LIST_FAILD = 'MOIGOIHOMSAU:FIND_ALL_FAILD'
export const MOIGOIHOMSAU_COUNT_ASSIGN_SUCCESS = 'MOIGOIHOMSAU:COUNT_ASSIGN_SUCCESS'
export const MOIGOIHOMSAU_COUNT_ASSIGN_FAILD = 'MOIGOIHOMSAU:COUNT_ASSIGN_FAILD'

export const MOIGOIHOMSAU_CREATE_SUCCESS = 'MOIGOIHOMSAU:CREATE_SUCCESS'
export const MOIGOIHOMSAU_CREATE_FAILD = 'MOIGOIHOMSAU:CREATE_FAILD'

export const MOIGOIHOMSAU_IMPORT_SUCCESS = 'MOIGOIHOMSAU:IMPORT_SUCCESS'
export const MOIGOIHOMSAU_SAVE_SUCCESS = 'MOIGOIHOMSAU:SAVE_SUCCESS'
export const MOIGOIHOMSAU_SAVE_FAILD = 'MOIGOIHOMSAU:SAVE_SUCCESS'

export const MOIGOIHOMSAU_DEL_SUCCESS = 'MOIGOIHOMSAU:DEL_SUCCESS'
export const MOIGOIHOMSAU_DEL_FAILD = 'MOIGOIHOMSAU:DEL_FAILD'

export const MOIGOIHOMSAU_ONE_SUCCESS = 'MOIGOIHOMSAU:FIND_ONE_SUCCESS'
export const MOIGOIHOMSAU_ONE_FAILD = 'MOIGOIHOMSAU:FIND_ONE_FAILD'

export const MOIGOIHOMSAU_HISTORY_LIST_SUCCESS = 'MOIGOIHOMSAU:HISTORY_FIND_ALL_SUCCESS'
export const MOIGOIHOMSAU_HISTORY_LIST_FAILD = 'MOIGOIHOMSAU:HISTORY_FIND_ALL_FAILD'

export const MOIGOIHOMSAU_UPDATE_FILTER = 'MOIGOIHOMSAU:UPDATE_FILTER'

export const MoigoihomsauAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,
}

function updateFilter(payload) {
    return { type: MOIGOIHOMSAU_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            MoigoihomsauService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(MoigoihomsauAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: MOIGOIHOMSAU_CREATE_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            MoigoihomsauService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(MoigoihomsauAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: MOIGOIHOMSAU_CREATE_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        MoigoihomsauService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MOIGOIHOMSAU_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { moigoihomsau } = getState()
        dispatch(AppAction.appLoading(true));
        MoigoihomsauService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...moigoihomsau.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MOIGOIHOMSAU_LIST_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { moigoihomsau } = getState();
        const page = moigoihomsau && typeof moigoihomsau.filter !== 'undefined' && moigoihomsau.filter && typeof moigoihomsau.filter.page !== 'undefined' ? moigoihomsau.filter.page : 0;
        const limit = moigoihomsau && typeof moigoihomsau.filter !== 'undefined' && moigoihomsau.filter && typeof moigoihomsau.filter.limit !== 'undefined' ? moigoihomsau.filter.limit : 10;
        MoigoihomsauService.findAll(page, limit, moigoihomsau.filter).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                const oldItems = moigoihomsau.items;
                const rsDataValues = rs.data.values;

                var uniqueItems = oldItems;
                for (var i = limit * page; i < limit * page + limit; i++) {
                    if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                        uniqueItems[i] = rsDataValues[i - limit * page];
                    } else if (typeof uniqueItems[i] !== 'undefined') {
                        delete uniqueItems[i];
                    }
                }
                
                dispatch(success({
                    items: uniqueItems,
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MOIGOIHOMSAU_LIST_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: MOIGOIHOMSAU_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            MoigoihomsauService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(MoigoihomsauAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: MOIGOIHOMSAU_SAVE_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            MoigoihomsauService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(MoigoihomsauAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: MOIGOIHOMSAU_CREATE_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        MoigoihomsauService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(MoigoihomsauAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MOIGOIHOMSAU_CREATE_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        MoigoihomsauService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(MoigoihomsauAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MOIGOIHOMSAU_DEL_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        MoigoihomsauService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MOIGOIHOMSAU_ONE_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        MoigoihomsauService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(MoigoihomsauAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { moigoihomsau } = getState()
        dispatch(AppAction.appLoading(true));
        MoigoihomsauService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...moigoihomsau.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: MOIGOIHOMSAU_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: MOIGOIHOMSAU_HISTORY_LIST_FAILD, error } }
}